<app-interfix-and-hypothesis-list
  [isHypothesis]="true"
  [list]="extraHypothesisList"
  [showProgressBar]="showProgressBar"
  [routerLinkPart]="'/morphology/extra-hypothesis-generation'"
  [errorMessageSource]="errorMessageSource"
  (deleteElementEvent)="deleteExtraHypothesis($event)"
></app-interfix-and-hypothesis-list>
